import { User } from '@/types';
import StorageBase from './storage';

export default class extends StorageBase {
  constructor() {
    super(sessionStorage);
  }
}
